import React from 'react';
import PropTypes from 'prop-types';
import {
	Button,
	Message
} from 'semantic-ui-react';

import styles from '../document-modal.module.css';

const SubmitModule = ( { handleSubmit } ) => {
	return (
		<div className={ styles.formContainer }>
			<Message compact>
				<Message.Header>Attention!</Message.Header>
				<br />
				<Message.Content>
					<p>You will not be able to make changes to this submission once it has been submitted.<br />Please ensure that all modules are complete before submitting.</p>
				</Message.Content>
			</Message>
			<br />
			<br />
			<Button
				color="pink"
				onClick={ handleSubmit }
				size="large"
			>
				Submit
			</Button>
		</div>
	);
};

SubmitModule.propTypes = { handleSubmit: PropTypes.func.isRequired };

export default SubmitModule;
